<template>
    <div class="auth-main">
        <SLeftSideComponent/>
        <div class="auth-right">
            <div class="right-main d-flex flex-column h-100">
                <!-- auth header -->
                <SRightHeaderComponent/>

                <!-- dynamic content section -->
                <slot></slot>
            
            </div>
        </div> 
    </div>
</template>
<script>
import SLeftSideComponent from '@/components/admin/layouts/standapp_left/SLeftSideComponent.vue'
import SRightHeaderComponent from '@/components/admin/layouts/standapp_right_header/SRightHeaderComponent.vue'
export default {
    name:'Standapp',
    components: {
        SLeftSideComponent,
        SRightHeaderComponent,
    },data() {
        return {
           
        }
    },methods:{
        
    }
}
</script>
<style scoped>
</style>